// extracted by mini-css-extract-plugin
module.exports = {"link":"ViewTransation_link__yUOl8"};